import {alias, createModelSchema, list} from "serializr";
import {SmartOfferBundle} from "../bundle-core/SmartOfferBundle";
import {SmartOfferBundleKind} from "../bundle-core/SmartOfferBundleKind";
import {FlashAdConfig} from "@/modules/redactor/models/smart-offer/bundle-flash-ad/FlashAdConfig";

export class SmartOfferBundleFlashAd extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.FLASH_AD);

        this._configs = [];
    }

    get configs() {
        return this._configs;
    }

    set configs(value) {
        this._configs = value;
    }

    empty() {
        if (super.empty()) {
            return true;
        }

        return !this.configs || this.configs.length === 0;
    }

    valid() {

        if (!this.configs || this.configs.length === 0) {
            return false;
        }

        if (this.configs.some(v => !v || !v.valid())) {
            return false;
        }

        return super.valid();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleFlashAd());
        } else if (target instanceof SmartOfferBundleFlashAd) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleFlashAd, {
    _configs: alias("configs", list(FlashAdConfig.schema()))
});